import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { DatasourceSummaryDatasource } from '@/types/api';

export type DataSourceViewMode = 'card' | 'table';

export const dataSourceViewModeAtom = atomWithStorage<DataSourceViewMode>(
  'dataSourceViewMode',
  'card',
);

export const dataSourceFilterAtom = atom<string | undefined>(undefined);

export const dataSourceToDeleteAtom = atom<
  DatasourceSummaryDatasource | undefined
>();

export interface DataSourceUpgradeState {
  dataSourceName: string;
  upgradePresetVersion: string | null;
}

export const dataSourceUpgradeDialogAtom = atom<DataSourceUpgradeState | null>(
  null,
);

export const showRequestNewDatasourceDialogAtom = atom<boolean>(false);
